import { render, staticRenderFns } from "./Internal-Project.vue?vue&type=template&id=e1940bc6"
import script from "./Internal-Project.vue?vue&type=script&lang=js"
export * from "./Internal-Project.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports